<template>
  <div
    v-if="acc"
    class="user_wrap"
  >
    <div class="top_header">
      <section class="profile-card">
        <div class="profile-main">
          <div class="user_header">
            <img
              :src="avatarSrc"
              alt=""
            >
          </div>
          <div class="user_name">
            <div class="user_title_row">
              <p class="user_mobile">
                {{ userMobile }}
              </p>
              <span
                v-if="vipName"
                class="vip-badge"
              >
                {{ vipName }}
              </span>
            </div>
            <div class="profile-meta">
              {{ $t('d.creditscore') }}:
              <strong
                class="user_mobile"
                style="font-size: 12px;"
              >{{ acc.credit }}</strong>
            </div>
            <div class="invite-row">
              <span>{{ $t('d.code') }}: 
                <strong
                  class="user_mobile"
                  style="font-size: 12px;"
                >{{ inviteCode }}</strong></span>
              <button
                type="button"
                class="copy-btn"
                @click.stop="copyYaocode"
              >
                {{ $t('invest_bank.copy') }}
              </button>
            </div>
          </div>
          <button
            type="button"
            class="msg"
            :aria-label="$t('user.setting')"
            @click="$router.push('/set')"
          >
            <van-icon
              name="setting-o"
              size="22"
            />
          </button>
        </div>
      </section>

      <section class="user_money">
        <div class="balance-main">
          <div class="balance-copy">
            <p>{{ $t('d.balance') }}</p>
            <strong>{{ formatAmount(data.money) }}</strong>
          </div>
          <button
            type="button"
            class="recharge-btn"
            :aria-label="$t('income.title')"
            @click="$router.push('/invest')"
          >
            <van-icon
              name="add"
              size="24"
            />
          </button>
        </div>
        <div class="money_num">
          <div class="stat-cell">
            <p>{{ formatAmount(data.frozenmoney) }}</p>
            <span>{{ $t('d.frozen') }}</span>
          </div>
          <div class="stat-cell">
            <p>{{ formatAmount(data.reward) }}</p>
            <span>{{ $t('d.todayrewards') }}</span>
          </div>
        </div>
      </section>
    </div>

    <div class="vip_group">
      <div class="vip_group_txt">
        {{ $t('pro2.upvip') }}
      </div>
      <img
        src="../images/ban3/vip.png"
        alt=""
        class="vip_group_img"
      >
    </div>

    <div class="list">
      <!-- <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/membership-card')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="vip-card-o"
              size="20"
            />
            <span class="custom-title">{{ $t('membershipCard.menuTitle') }}</span>
          </span>
        </template>
      </van-cell> -->
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/invest')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="credit-pay"
              size="20"
            />
            <span class="custom-title">{{ $t('income.title') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/cash')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="share-o"
              size="20"
            />
            <span class="custom-title">{{ $t('user.withdraw') }}</span>
          </span>
        </template>
      </van-cell>
      <!--      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/ordering')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="gem-o"
              size="20"
            />
            <span class="custom-title">{{ $t('grapHome.taskOrder') }}</span>
          </span>
        </template>
      </van-cell> -->
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/order')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="gem-o"
              size="20"
            />
            <span class="custom-title">{{ $t('grapHome.taskOrder') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/cashlist')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="certificate"
              size="20"
            />
            <span class="custom-title">{{ $t('user.withdrawalRecord') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/funds')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="debit-pay"
              size="20"
            />
            <span class="custom-title">{{ $t('pro2.transactionhis') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/notice')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="smile-comment-o"
              size="20"
            />
            <span class="custom-title">{{ $t('notice.message') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="menu-cell"
        is-link
        @click="$router.push('/kefu')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="service"
              size="20"
            />
            <span class="custom-title">{{ $t('webindex.custserver') }}</span>
          </span>
        </template>
      </van-cell>

      <div class="logout-wrap">
        <button
          type="button"
          class="history_coupon"
          @click="logout"
        >
          <span>{{ $t('safe.signOut') }}</span>
        </button>
      </div>
    </div>

    <van-dialog
      v-model="noticeDialogShow"
      width="90%"
      class="site-notice-dialog"
      :title="currentNoticeTitle"
      :confirm-button-text="$t('utils.confirm')"
      @confirm="confirmNoticeRead"
    >
<!--      <div
        v-if="currentNotice && currentNotice.add_time"
        class="site-notice-time"
      >
        {{ currentNotice.add_time }}
      </div> -->
      <div
        class="site-notice-body"
        v-html="currentNoticeContent"
      />
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import {
  Icon,
  Cell,
  CellGroup,
  Dialog,
} from "vant";

Vue.use(Cell).use(CellGroup).use(Icon).use(Dialog);

export default {
  name: "User",
  components: {
  },
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      data: {},
      islogin: false,
      show_kefu: false,
      msg_show: true,
      vip: null,
      acc: null,
      noticeTimer: null,
      noticeChecking: false,
      noticeDialogShow: false,
      currentNotice: null,
      app: null,
      eye: 1
    };
  },
  computed: {
    avatarSrc() {
      return this.app && this.app.fuli1 ? this.app.fuli1 : '';
    },
    userMobile() {
      return this.acc && this.acc.mobile ? this.acc.mobile : '--';
    },
    vipName() {
      return this.acc && this.acc.vip ? this.acc.vip.name : '';
    },
    inviteCode() {
      var code = this.data && this.data.yaocode;
      return code === undefined || code === null || code === '' ? '--' : code;
    },
    currentNoticeTitle() {
      return this.currentNotice && this.currentNotice.title ? this.currentNotice.title : this.$t('notice.message');
    },
    currentNoticeContent() {
      return this.currentNotice && this.currentNotice.content ? this.currentNotice.content : '';
    }
  },
  created() {
    this.$parent.footer('user');
  },
  mounted() {
    this.islogin = localStorage.getItem('token') != null;
    if (!this.islogin) {
      this.$router.push("/login");
      return;
    }
    this.start();
    this.startNoticePolling();
    document.body.addEventListener(
      "scroll",
      () => {
        if (!this.show_kefu) {
          return;
        }
        this.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      (ev) => {
        if (ev.target.className != "kefu_img") {
          this.show_kefu = false;
        }
      },
      false
    );
  },
  beforeDestroy() {
    this.stopNoticePolling();
  },
  methods: {
    startNoticePolling() {
      this.stopNoticePolling();
      this.checkUnreadNotice();
      this.noticeTimer = setInterval(() => {
        this.checkUnreadNotice();
      }, 10000);
    },
    stopNoticePolling() {
      if (this.noticeTimer) {
        clearInterval(this.noticeTimer);
        this.noticeTimer = null;
      }
    },
    checkUnreadNotice() {
      if (!this.islogin || this.noticeChecking || this.noticeDialogShow) {
        return;
      }
      this.noticeChecking = true;
      Fetch("/index/sync", {}, null, false).then((r) => {
        var unread = Number(r.data) || 0;
        if (unread <= 0) {
          return null;
        }
        return Fetch('/user/notice', {}, null, false).then((res) => {
          var list = res.data && res.data.list ? res.data.list : [];
          var notice = list.find(item => Number(item.uid) !== 0 && Number(item.status) === 0);
          if (notice && !this.noticeDialogShow) {
            this.currentNotice = notice;
            this.noticeDialogShow = true;
          }
          return notice;
        });
      }).catch(() => {}).then(() => {
        this.noticeChecking = false;
      });
    },
    confirmNoticeRead() {
      var notice = this.currentNotice;
      this.noticeDialogShow = false;
      this.currentNotice = null;
      if (!notice || !notice.id) {
        return;
      }
      Fetch('/user/notice_view', {
        id: notice.id
      }, null, false).catch(() => {});
    },
    kefu_to() {
      var link = this.app && this.app.kefu_link;
      if (link) {
        window.location.href = link;
      }
    },
    downapp() {
      top.location.href = '/app.apk';
    },
    copy() {
      this.$toast({
        background: "#07c160",
        message: this.$t('invest_qrcode.copySucceeded'),
      });
    },
    copyYaocode() {
      var yaocode = this.data && this.data.yaocode;
      this.copyText(yaocode === undefined || yaocode === null ? '' : String(yaocode));
    },
    copyText(text) {
      if (!text) {
        return;
      }
      if (this.copyTextBySelection(text)) {
        this.copy();
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.copy();
        }).catch(() => {});
      }
    },
    copyTextBySelection(text) {
      var input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', 'readonly');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      input.style.top = '0';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.focus();
      input.select();
      input.setSelectionRange(0, input.value.length);
      var copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (e) {
        copied = false;
      }
      document.body.removeChild(input);
      return copied;
    },
    formatAmount(value) {
      var amount = (1*value).toFixed(2);
      return amount ? amount : 0.00;
    },
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data;
      });
      Fetch('/user/info').then((r) => {
        this.data = r.data;
        this.acc = r.data;
        if (r.data.vip) {
          this.vip = r.data.vip;
        }
      });
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace("/");
    }
  }
};
</script>

<style lang="less" scoped>
.user_wrap {
  width: 100%;
  min-height: 100vh;
  padding: 0 0 118px;
  background: #111;
  color: #f6f6f6;
  box-sizing: border-box;
}

button {
  border: 0;
  font: inherit;
  cursor: pointer;
}

.top_header {
  width: 100%;
  padding: 16px 20px 0;
  background:
    radial-gradient(circle at 18% -12%, rgba(110, 124, 240, 0.42) 0, rgba(110, 124, 240, 0) 35%),
    linear-gradient(180deg, #101010 0%, #111 100%);
  box-sizing: border-box;
}

.profile-card,
.user_money,
.vip_group,
.list {
  overflow: hidden;
  border-radius: 12px;
  background: #222;
  box-sizing: border-box;
}

.profile-main {
  min-height: 98px;
  padding: 16px;
  display: flex;
  align-items: center;
  position: relative;
  background: linear-gradient(135deg, #6878ea 0%, #7b45a7 100%);
  box-sizing: border-box;
}

.user_header {
  width: 62px;
  height: 62px;
  flex: 0 0 62px;
  overflow: hidden;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.72);
  background: #111;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.user_header img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.user_name {
  min-width: 0;
  flex: 1;
  margin-left: 14px;
  padding-right: 42px;
}

.user_title_row {
  min-width: 0;
  display: flex;
  align-items: center;
}

.user_mobile {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.vip-badge {
  flex: 0 0 auto;
  margin-left: 8px;
  padding: 4px 10px;
  border-radius: 14px;
  color: #fff;
  background: rgba(2, 4, 9, 0.36);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
}

.profile-meta,
.invite-row {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
  line-height: 18px;
}

.profile-meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.invite-row {
  min-width: 0;
  display: flex;
  align-items: center;
}

.invite-row span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.copy-btn {
  height: 26px;
  flex: 0 0 auto;
  margin-left: 8px;
  padding: 0 10px;
  border-radius: 8px;
  border: 0;
  background: rgba(2, 4, 9, 0.56);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 26px;
  box-sizing: border-box;
}

.msg {
  width: 34px;
  height: 34px;
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: rgba(2, 4, 9, 0.34);
}

.user_money {
  margin-top: 12px;
}

.balance-main {
  min-height: 96px;
  padding: 18px 18px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #222;
  border-bottom: 1px solid #303030;
  box-sizing: border-box;
}

.balance-copy {
  min-width: 0;
}

.balance-copy p {
  margin: 0 0 8px;
  color: rgba(255, 255, 255, 0.62);
  font-size: 14px;
  line-height: 20px;
}

.balance-copy strong {
  display: block;
  overflow: hidden;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.recharge-btn {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(180deg, #8877f2 0%, #644ec1 100%);
  box-shadow: 0 8px 18px rgba(100, 78, 193, 0.35);
}

.money_num {
  padding: 14px 12px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  box-sizing: border-box;
}

.stat-cell {
  min-width: 0;
  padding: 12px 8px;
  border-radius: 10px;
  background: rgba(35, 35, 35, 0.82);
  box-shadow: inset 0 0 0 1px #303030;
  text-align: center;
  box-sizing: border-box;
}

.stat-cell p {
  margin: 0;
  overflow: hidden;
  color: #f4f4f4;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.stat-cell span {
  display: block;
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.56);
  font-size: 12px;
  line-height: 18px;
}

.vip_group {
  min-height: 74px;
  margin: 18px 20px 0;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(100deg, #8c15a6 0%, #5c0e7a 100%);
}

.vip_group_txt {
  min-width: 0;
  flex: 1;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  word-break: break-word;
}

.vip_group_img {
  width: 58px;
  height: 58px;
  flex: 0 0 58px;
  margin-left: 14px;
  object-fit: contain;
}

.list {
  margin: 18px 20px 0;
  padding: 4px 14px 18px;
}

/deep/ .van-cell {
  min-height: 54px;
  padding: 0;
  display: flex;
  align-items: center;
  border: 0;
  background: transparent;
  color: #f6f6f6;
  line-height: 54px;
  box-sizing: border-box;
}

/deep/ .van-cell:not(:last-of-type) {
  border-bottom: 1px solid #303030;
}

/deep/ .van-cell::after {
  display: none;
}

/deep/ .van-cell__title {
  min-width: 0;
}

/deep/ .van-cell__right-icon {
  color: rgba(255, 255, 255, 0.46);
  font-size: 16px;
  line-height: 54px;
}

.menu-title {
  min-width: 0;
  display: flex;
  align-items: center;
}

.menu-icon {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  margin-right: 10px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(180deg, #8877f2 0%, #644ec1 100%);
}

.menu-cell:nth-of-type(2n) .menu-icon {
  background: linear-gradient(100deg, #43b5f7 0%, #10e7f5 100%);
}

.menu-cell:nth-of-type(3n) .menu-icon {
  background: linear-gradient(100deg, #ff7c98 0%, #ffdb3f 100%);
}

.menu-cell:nth-of-type(4n) .menu-icon {
  background: linear-gradient(90deg, #ff6467 0%, #ff5621 100%);
}

.custom-title {
  overflow: hidden;
  color: #f5f5f5;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.logout-wrap {
  padding-top: 18px;
}

.history_coupon {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 0;
  background: linear-gradient(90deg, #ff6467 0%, #ff5621 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

/deep/ .site-notice-dialog {
  overflow: hidden;
  border-radius: 14px;
  background: #222;
  color: #f6f6f6;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.48);
}

/deep/ .site-notice-dialog .van-dialog__header {
  padding: 24px 24px 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 22px;
  text-align: center;
}

/deep/ .site-notice-dialog .van-dialog__content {
  padding: 0 24px 22px;
  background: #222;
}

/deep/ .site-notice-dialog .van-dialog__footer {
  height: 50px;
  background: linear-gradient(90deg, #6479ea 0%, #8b55c6 100%);
  border-radius: 0 0 14px 14px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

/deep/ .site-notice-dialog .van-dialog__footer::after {
  border-width: 0;
}

/deep/ .site-notice-dialog .van-dialog__confirm {
  height: 50px;
  border-radius: 0 0 14px 14px;
  background: transparent;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 50px;
}

.site-notice-time {
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.64);
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}

.site-notice-body {
  max-height: 54vh;
  overflow-y: auto;
  color: #f6f6f6;
  font-size: 12px;
  font-weight: 600;
  line-height: 28px;
  word-break: break-word;
}

/deep/ .site-notice-body p {
  margin: 0 0 10px;
}

/deep/ .site-notice-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

@media screen and (max-width: 374px) {
  .top_header {
    padding-right: 12px;
    padding-left: 12px;
  }

  .vip_group,
  .list {
    margin-right: 12px;
    margin-left: 12px;
  }

  .list {
    padding-right: 12px;
    padding-left: 12px;
  }

  .profile-main {
    padding: 14px;
  }

  .user_header {
    width: 56px;
    height: 56px;
    flex-basis: 56px;
  }

  .user_name {
    margin-left: 12px;
    padding-right: 38px;
  }

  .balance-copy strong {
    font-size: 16px;
    line-height: 24px;
  }

  .vip_group_img {
    width: 50px;
    height: 50px;
    flex-basis: 50px;
  }
}
</style>
